/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryReports.defs.js'
export { main as default } from './queryReports.defs.js'
